<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<template>
    <vx-card title="" class="toggle-container">
        <vs-popup class="house_sqft"  title="House Size sqft Change" :active.sync="size_adjustment_popup">
          <p>This square footage either not confirmed by our records or differs substantially from other Toggles. Please select:</p>
          <vs-radio v-model="send_market_leader" vs-value="1">Send Market Leader a Note to Correct sqft</vs-radio>
          <vs-divider color="primary"></vs-divider>
          <vs-radio v-model="override" vs-value="1">Override and continue for comp purposes</vs-radio>
          <p><small>Note: This sqft change will only be valid for this toggle.</small></p>

          <vs-button @click="size_adjustment_submit" color="success" type="filled">Continue</vs-button>
          <vs-button @click="size_adjustment_popup=false" color="primary" type="border">Cancel</vs-button>
        </vs-popup>
        <div class="mt-1" id="toggle-block" v-show="place_id !== null">
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <h3 class="address">{{address}}:</h3>
            </vs-col>
          </vs-row>
          <vs-row class="mt-5" vs-align="flex-start" vs-type="flex" vs-justify="center">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="4" vs-sm="4" vs-md="4" vs-xs="6">
              <vs-input
                v-validate="'required|integer|min:0|max:400000'"
                data-vv-validate-on="blur"
                name="house_sqft"
                icon-no-border
                icon="icon icon-crop"
                icon-pack="feather"
                label-placeholder="**Confirm House sqft:"
                v-model="house_sqft"
                @change="calculate_toggle(true)"
                size="small" />
              <span class="text-danger text-sm">{{ errors.first('house_sqft') }}</span>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="2" vs-sm="2" vs-md="2" vs-xs="6">
              <span class="danger">Rank:</span> <span class="bordered-value" v-show="house_sqft_rank !== null">{{house_sqft_rank}}</span>
            </vs-col>
          </vs-row>
           <vs-row class="mt-5" vs-align="flex-start" vs-type="flex" vs-justify="center">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="4" vs-sm="4" vs-md="4" vs-xs="6">
             <vs-input
                v-validate="'required|integer|min:0|max:400000'"
                data-vv-validate-on="blur"
                name="lot_sqft"
                icon-no-border
                icon="icon icon-crop"
                icon-pack="feather"
                label-placeholder="**Confirm Lot Size sqft:"
                v-model="lot_sqft"
                @change="calculate_toggle"
                size="small" />
              <span class="text-danger text-sm">{{ errors.first('lot sqft') }}</span>
            </vs-col>
            <vs-col color="rgb(45, 208, 129)" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="2" vs-sm="2" vs-md="2" vs-xs="6">
              <span class="danger">Rank:</span> <span class="bordered-value" v-show="lot_size_rank !== null">{{lot_size_rank}}</span>
            </vs-col>
          </vs-row>

          <vs-row class="mt-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <div class="centerx">
                <h3>Estimated Price: $ <b>{{Number(estimated_price).toLocaleString()}}</b></h3> 
              </div>
            </vs-col>
          </vs-row>
          
          <vs-divider/>

          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <div class="centerx">
                <h3 class="blue">Lot-location Value: $ <b>{{Number(lot_location_value).toLocaleString()}}</b></h3> 
              </div>
            </vs-col>
          </vs-row>

          <vs-row class="mt-10" vs-align="flex-start" vs-type="flex" vs-justify="center">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-xs="12" vs-sm="12">
              <ReavnDropdown @change="calculate_toggle" :color-options="neighborhood_colors" :label="neighborhood_label" empty-option="Neighborhood" input-id="neighborhood" v-model="neighborhood"></ReavnDropdown>
              <ReavnDropdown @change="calculate_toggle" :color-options="school_colors" :label="school_label" empty-option="None" input-id="school" v-model="school"></ReavnDropdown>
              <ReavnDropdown @change="calculate_toggle" :color-options="location_colors" :label="location_label" empty-option="None" input-id="location" v-model="location"></ReavnDropdown>
            </vs-col>

            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-xs="12" vs-sm="12">
            <span class="danger">Rank:</span> <span class="bordered-value">{{lot_location}}%</span>
            </vs-col>
          </vs-row>

          <vs-row class="mt-1">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <div class="centerx">
                <vs-slider :min="1" :max="100" @change="slider" color="rgb(45, 208, 129)" v-model="lot_location" />
              </div>
            </vs-col>
          </vs-row>

          <vs-divider/>

          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <div class="centerx">
                <h4 class="blue">Structure-Condition: $ <b>{{Number(structure_location_value).toLocaleString()}}</b></h4> 
              </div>
            </vs-col>
          </vs-row>

          
          <vs-row class="mt-10">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-xs="12" vs-sm="12">
                <ReavnDropdown :color-options="design_colors" :label="design_label" empty-option="Design &amp; Layout" @change="calculate_toggle" input-id="design" v-model="design"></ReavnDropdown>
                <ReavnDropdown :color-options="finish_colors" :label="finish_label" empty-option="Finish &amp; Features" @change="calculate_toggle" input-id="finish" v-model="finish"></ReavnDropdown>
                <ReavnDropdown :color-options="condition_colors" :label="condition_label" empty-option="Condition" @change="calculate_toggle" input-id="condition" v-model="condition"></ReavnDropdown>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-xs="12" vs-sm="12">
            <span class="danger">Rank:</span> <span class="bordered-value">{{structure_condition}}%</span>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <div class="centerx">
                <vs-slider :min="1" :max="100" @change="slider" color="rgb(45, 208, 129)" v-model="structure_condition" />
              </div>
            </vs-col>
          </vs-row>

          <vs-row class="mt-10">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button @click="submit" size="small" color="primary" type="filled">Accept</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button @click="advanced" color="success" size="small" type="filled">Advanced</vs-button>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <p class="sep-line">And go to results</p>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <p class="sep-line">for more detail</p>
            </vs-col>
          </vs-row>

          <vs-row class="mt-40">
            <vs-col vs-type="flex" vs-align="center" vs-justify="center" vs-w="12">
            <div class="center">
              
            <p>
              <router-link :to="{name:'tips'}" class="mb-4 underline">Tips</router-link> - 
              <router-link :to="{name:'tutorials'}" class="mb-4 underline">Tutorials</router-link> - 
              <router-link :to="{name:'Settings'}" class="mb-4 underline">Settings</router-link>
            </p>
            </div>
            </vs-col>
          </vs-row>
        </div>
    </vx-card>
</template>

<script>

import {reavnConfig, dropdown_colors} from '@/../reavnConfig.js'
import ReavnDropdown from '@/components/reavn-dropdown/reavn-dropdown.vue'
import axios from 'axios'
import authHeader from '@/services/auth-header'

export default {
  name: 'Toggle',
  data () {
    return {
      send_market_leader: null,
      override: null,
      size_adjustment_popup: false,
      house_size_validation_result: null,
      toggle_id: null,
      privacy: 'private',
      place_id: null,
      zip: null,
      lat: null,
      lng: null,
      house_sqft_rank: 50,
      lot_size_rank: 50,
      address: '',
      state: null,
      estimated_price: null,
      lot_location_value: null,
      structure_location_value: null,
      lot_location:50,
      rank_lot_location: null,
      rank_structure_condition: null,
      structure_condition: 50,
      lot_sqft: 1000,
      house_sqft: 1000,
      widthx:50,
      heightx:50,
      school: 3,
      location: 3,
      neighborhood: 3,
      design: 3,
      finish: 3,
      condition: 3,
      neighborhood_label: 'Neighborhood',
      neighborhood_colors: [
        {
          'hex': dropdown_colors._7,
          'name': 'Neighborhood',
          'value': 7
        },
        {
          'hex': dropdown_colors._6,
          'name': 'Neighborhood',
          'value': 6
        },
        {
          'hex': dropdown_colors._5,
          'name': 'Neighborhood',
          'value': 5
        },
        {
          'hex': dropdown_colors._4,
          'name': 'Neighborhood',
          'value': 4
        },
        {
          'hex': dropdown_colors._3,
          'name': 'Neighborhood',
          'value': 3
        },
        {
          'hex': dropdown_colors._2,
          'name': 'Neighborhood',
          'value': 2
        },
        {
          'hex': dropdown_colors._1,
          'name': 'Neighborhood',
          'value': 1
        },
        {
          'hex': dropdown_colors._0,
          'name': 'Neighborhood',
          'value': 0
        }
      ],
      school_label: 'School',
      school_colors: [
        {
          'hex': dropdown_colors._7,
          'name': 'School',
          'value': 7
        },
        {
          'hex': dropdown_colors._6,
          'name': 'School',
          'value': 6
        },
        {
          'hex': dropdown_colors._5,
          'name': 'School',
          'value': 5
        },
        {
          'hex': dropdown_colors._4,
          'name': 'School',
          'value': 4
        },
        {
          'hex': dropdown_colors._3,
          'name': 'School',
          'value': 3
        },
        {
          'hex': dropdown_colors._2,
          'name': 'School',
          'value': 2
        },
        {
          'hex': dropdown_colors._1,
          'name': 'School',
          'value': 1
        },
        {
          'hex': dropdown_colors._0,
          'name': 'School',
          'value': 0
        }
      ],
      location_label: 'Location',
      location_colors: [
        {
          'hex': dropdown_colors._7,
          'name': 'Location',
          'value': 7
        },
        {
          'hex': dropdown_colors._6,
          'name': 'Location',
          'value': 6
        },
        {
          'hex': dropdown_colors._5,
          'name': 'Location',
          'value': 5
        },
        {
          'hex': dropdown_colors._4,
          'name': 'Location',
          'value': 4
        },
        {
          'hex': dropdown_colors._3,
          'name': 'Location',
          'value': 3
        },
        {
          'hex': dropdown_colors._2,
          'name': 'Location',
          'value': 2
        },
        {
          'hex': dropdown_colors._1,
          'name': 'Location',
          'value': 1
        },
        {
          'hex': dropdown_colors._0,
          'name': 'Location',
          'value': 0
        }
      ],
      design_label: 'Design',
      design_colors: [
        {
          'hex': dropdown_colors._7,
          'name': 'Design',
          'value': 7
        },
        {
          'hex': dropdown_colors._6,
          'name': 'Design',
          'value': 6
        },
        {
          'hex': dropdown_colors._5,
          'name': 'Design',
          'value': 5
        },
        {
          'hex': dropdown_colors._4,
          'name': 'Design',
          'value': 4
        },
        {
          'hex': dropdown_colors._3,
          'name': 'Design',
          'value': 3
        },
        {
          'hex': dropdown_colors._2,
          'name': 'Design',
          'value': 2
        },
        {
          'hex': dropdown_colors._1,
          'name': 'Design',
          'value': 1
        },
        {
          'hex': dropdown_colors._0,
          'name': 'Design',
          'value': 0
        }
      ],
      finish_label: 'Finish',
      finish_colors: [
        {
          'hex': dropdown_colors._7,
          'name': 'Finish',
          'value': 7
        },
        {
          'hex': dropdown_colors._6,
          'name': 'Finish',
          'value': 6
        },
        {
          'hex': dropdown_colors._5,
          'name': 'Finish',
          'value': 5
        },
        {
          'hex': dropdown_colors._4,
          'name': 'Finish',
          'value': 4
        },
        {
          'hex': dropdown_colors._3,
          'name': 'Finish',
          'value': 3
        },
        {
          'hex': dropdown_colors._2,
          'name': 'Finish',
          'value': 2
        },
        {
          'hex': dropdown_colors._1,
          'name': 'Finish',
          'value': 1
        },
        {
          'hex': dropdown_colors._0,
          'name': 'Finish',
          'value': 0
        }
      ],
      condition_label: 'Condition',
      condition_colors: [
        {
          'hex': dropdown_colors._7,
          'name': 'Condition',
          'value': 7
        },
        {
          'hex': dropdown_colors._6,
          'name': 'Condition',
          'value': 6
        },
        {
          'hex': dropdown_colors._5,
          'name': 'Condition',
          'value': 5
        },
        {
          'hex': dropdown_colors._4,
          'name': 'Condition',
          'value': 4
        },
        {
          'hex': dropdown_colors._3,
          'name': 'Condition',
          'value': 3
        },
        {
          'hex': dropdown_colors._2,
          'name': 'Condition',
          'value': 2
        },
        {
          'hex': dropdown_colors._1,
          'name': 'Condition',
          'value': 1
        },
        {
          'hex': dropdown_colors._0,
          'name': 'Condition',
          'value': 0
        }
      ]
    }
  },  
  computed: {
    active_user () { 
      return this.$store.state.active_user
    }
  },
  mounted () {
    this.toggle_id = this.$route.params.toggle_id
    this.get_toggle_data()
  },
  methods: {
    customLabel (title) {
      return `${title}`
    },
    slider (value) {
      this.widthx = value
      this.heightx = value
      this.calculate_toggle()
    },
    size_adjustment_submit () {
      if (this.override === '1') {
        this.house_size_validation_result = true
      }
      if (this.send_market_leader === '1') {
        this.send_market_leader_email()
        this.house_size_validation_result = true
      }
      this.size_adjustment_popup = false
    },
    send_market_leader_email () {
      const toggle = {
        toggler: `${this.$store.state.active_user.first_name} ${this.$store.state.active_user.last_name}`,
        new_size: this.house_sqft,
        zip: this.zip,
        address: this.address,
        place_id: this.place_id
      }
      axios.post(`${process.env.VUE_APP_API_HOST}data/send_market_leader`, toggle, authHeader()).then(response => {
        this.loading = false
        if (response.data.code === '200') {
          this.house_size_validation_result = true
          return true
        }
      })
        .catch(error => {
          this.loading = false
          return false
        })
    },
    house_size_validation () {
      if (this.house_size_validation_result === true) {
        return true
      }
      if (this.loading === true) {
        return false
      }
      //this.loading = true
      const toggle = {
        lot_location: this.lot_location,
        structure_condition: this.structure_condition,
        lot_sqft: this.lot_sqft,
        house_sqft: this.house_sqft,
        school: this.school,
        location: this.location,
        neighborhood: this.neighborhood,
        design: this.design,
        finish: this.finish,
        state: this.state,
        condition: this.condition,
        zip: this.zip,
        place_id: this.place_id
      }
      axios.post(`${process.env.VUE_APP_API_HOST}toggle/house_size_validation`, toggle, authHeader()).then(response => {
        this.loading = false
        if (response.data.status === false) {
          this.size_adjustment_popup = true
          return false
        }
      })
        .catch(error => {
          this.loading = false
          return false
        })
    },
    calculate_toggle (size_changed) {
      if (size_changed === true && this.$store.state.active_user.market_leader === false) {
        if (this.house_size_validation() === false) {
          return false
        }
      }
      if (this.loading === true) {
        return false
      }
      this.loading = true
      const toggle = {
        lot_location: this.lot_location,
        structure_condition: this.structure_condition,
        lot_sqft: this.lot_sqft,
        house_sqft: this.house_sqft,
        lot_size: this.lot_sqft,
        zip: this.zip
      }
      axios.post(`${process.env.VUE_APP_API_HOST}toggle/calculate`, toggle, authHeader()).then(response => {
        this.loading = false
        if (response.data.lot_location_value) {
          this.lot_location_value = response.data.lot_location_value
          this.structure_location_value = response.data.structure_location_value
          this.estimated_price = response.data.estimated_price
          this.house_sqft_rank = response.data.house_sqft_rank
          this.lot_size_rank = response.data.lot_size_rank
        }
      })
        .catch(error => {
          this.lot_location_value = null
          this.structure_location_value = null
          this.error = error.response.message
          this.loading = false
          return false
        })
    },
    submit () {
      const toggle = {
        toggle_id: this.toggle_id,
        estimated_price: this.estimated_price,
        lot_location_value: this.lot_location_value,
        structure_location_value: this.structure_location_value,
        lot_location: this.lot_location,
        structure_condition: this.structure_condition,
        lot_sqft: this.lot_sqft,
        house_sqft: this.house_sqft,
        school: this.school,
        state: this.state,
        location: this.location,
        address: this.address,
        neighborhood: this.neighborhood,
        design: this.design,
        finish: this.finish,
        privacy: this.privacy,
        place_id: this.place_id,
        lat: this.lat,
        lng: this.lng,
        zip: this.zip,
        condition: this.condition
      } 
      axios.post(`${process.env.VUE_APP_API_HOST}toggle/save`, toggle, authHeader()).then(response => {
        if (response.data.toggle_id) {
          this.$vs.notify({
            'time':10000,
            'title':'success',
            'text':'The toggle was submitted!',
            'color':'info'
          })
          this.$router.push('/toggles')
        }
      })
        .catch(error => {
          this.error = error.response.data.message
          return false
        })
    },
    advanced () {
      const toggle = {
        estimated_price: this.estimated_price,
        lot_location_value: this.lot_location_value,
        structure_location_value: this.structure_location_value,
        lot_location: this.lot_location,
        structure_condition: this.structure_condition,
        lot_sqft: this.lot_sqft,
        address: this.address,
        state: this.state,
        house_sqft: this.house_sqft,
        school: this.school,
        location: this.location,
        neighborhood: this.neighborhood,
        design: this.design,
        finish: this.finish,
        place_id: this.place_id,
        zip: this.zip,
        privacy: this.privacy,
        condition: this.condition,
        lat: this.lat,
        lng: this.lng,
        advanced: 1
      }
      axios.post(`${process.env.VUE_APP_API_HOST}toggle/save`, toggle, authHeader()).then(response => {
        if (response.data.toggle_id) {
          this.$vs.notify({
            'time':10000,
            'title':'success',
            'text':'The toggle was submitted!',
            'color':'info'
          })
          this.$router.push(`/advanced-toggle/${response.data.toggle_id}`)
        }
      })
        .catch(error => {
          this.error = error.response.data.message
          return false
        })

     
    },
    get_place_data () {
      if (this.toggle_id) {
        axios.get(`${process.env.VUE_APP_API_HOST}toggle/get/${this.toggle_id}`, authHeader()).then(
          result => {
            if (result.data.toggle.place_id) {
              this.estimated_price = result.data.toggle.estimated_price
              this.lot_location_value = result.data.toggle.lot_location_value
              this.structure_location_value = result.data.toggle.structure_location_value
              this.lot_location = result.data.toggle.lot_location
              this.structure_condition = result.data.toggle.structure_condition
              this.lot_sqft = result.data.toggle.lot_sqft
              this.house_sqft = result.data.toggle.house_sqft
              this.school = result.data.toggle.school
              this.location = result.data.toggle.location
              this.address = result.data.toggle.address
              this.neighborhood = result.data.toggle.neighborhood
              this.design = result.data.toggle.design
              this.finish = result.data.toggle.finish
              this.curb = result.data.toggle.curb
              this.place_id = result.data.toggle.place_id
              this.zip = result.data.toggle.zip
              this.condition = result.data.toggle.condition
              this.privacy = result.data.toggle.privacy
              this.community = result.data.toggle.community
              this.views = result.data.toggle.views
              this.house_sqft_rank = result.data.toggle.house_sqft_rank
              this.lot_size_rank = result.data.toggle.lot_size_rank
              this.traffic = result.data.toggle.traffic
              this.landscape = result.data.toggle.landscape
              this.site_location = result.data.toggle.site_location
              this.neighborhood_slider = result.data.toggle.neighborhood_slider
              this.site_location_slider = result.data.toggle.site_location_slider
              this.location_slider = result.data.toggle.location_slider
              if (this.site_location_slider <= 0 || this.site_location_slider === null) {
                this.site_location_slider = this.lot_location
              }
              if (this.neighborhood_slider <= 0 || this.neighborhood_slider === null) {
                this.neighborhood_slider = this.lot_location
              }
              if (this.location_slider <= 0  || this.location_slider === null) {
                this.location_slider = this.lot_location
              }
            }
          },
          error => {
            this.$vs.notify({
              'time':10000,
              'title':'Error',
              'text':error.message,
              'color':'danger'
            })
            return false
          })
        }
    },
    get_toggle_data () {
      axios.get(`${process.env.VUE_APP_API_HOST}toggle/get/${this.toggle_id}`, authHeader()).then(result => {
        this.loading = false
        if (result.data.status === false) {
          this.size_adjustment_popup = true
          return false
        }

        this.estimated_price = result.data.toggle.estimated_price
        this.lot_location_value = result.data.toggle.lot_location_value
        this.structure_location_value = result.data.toggle.structure_location_value
        this.lot_location = result.data.toggle.lot_location
        this.structure_condition = result.data.toggle.structure_condition
        this.lot_sqft = result.data.toggle.lot_sqft
        this.house_sqft = result.data.toggle.house_sqft
        this.school = result.data.toggle.school
        this.location = result.data.toggle.location
        this.address = result.data.toggle.address
        this.neighborhood = result.data.toggle.neighborhood
        this.design = result.data.toggle.design
        this.finish = result.data.toggle.finish
        this.curb = result.data.toggle.curb
        this.place_id = result.data.toggle.place_id
        this.zip = result.data.toggle.zip
        this.condition = result.data.toggle.condition
        this.privacy = result.data.toggle.privacy
        this.community = result.data.toggle.community
        this.views = result.data.toggle.views
        this.house_sqft_rank = result.data.toggle.house_sqft_rank
        this.lot_size_rank = result.data.toggle.lot_size_rank
        this.traffic = result.data.toggle.traffic
        this.landscape = result.data.toggle.landscape
        this.site_location = result.data.toggle.site_location
        this.neighborhood_slider = result.data.toggle.neighborhood_slider
        this.site_location_slider = result.data.toggle.site_location_slider
        this.location_slider = result.data.toggle.location_slider
        if (this.site_location_slider <= 0 || this.site_location_slider === null) {
          this.site_location_slider = this.lot_location
        }
        if (this.neighborhood_slider <= 0 || this.neighborhood_slider === null) {
          this.neighborhood_slider = this.lot_location
        }
        if (this.location_slider <= 0  || this.location_slider === null) {
          this.location_slider = this.lot_location
        }
      })
      .catch(error => {
        this.loading = false
        return false
      })
    }
  }
}
</script>
